import {useNavigate} from "react-router-dom";
import {START_BATCH} from "../../../routes";
import {Button, Card, CardActions, CardContent, CardHeader, Container, Typography} from "@mui/material";
import React from "react";
import {useTranslation} from 'react-i18next';

export const EmptyBatch = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const navigateToWizard = () => {navigate(START_BATCH)}
  return (
    <Container sx={{marginBottom: '2rem', marginTop:'1rem',textAlign: 'center'}}>
      <Card >
        <CardHeader title={t('batch.emptyBatch.title')} subheader={t('batch.emptyBatch.subtitle')}/>
        <CardContent>
          <Typography>
            {t('batch.emptyBatch.message1')}
            <br/>
            {t('batch.emptyBatch.message2')}
          </Typography>

        </CardContent>
        <CardActions sx={{textAlign: 'center', justifyContent: 'space-evenly'}}>
          <Button onClick={navigateToWizard} variant="contained">{t('batch.emptyBatch.button')}</Button>
        </CardActions>
      </Card>
    </Container>
  )
}
